import React from 'react';
import {useSelector} from 'react-redux';

import {COLUMNS} from '../../constants';
import {useGetAccountSearchResultMobileUsers} from '../../hooks/useGetAccountSearchResultMobileUsers';
import {accountSearchResultResultSelector} from '../../slices/account-search-result.slice';

import {HeaderCaption} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';


type Props = {
    accountIds: number[],
    totalCount: number,
};

const MobileEnabledUsersHeaderController = ({accountIds, totalCount}: Props) => {
    const {isLoading, loadingError} = useGetAccountSearchResultMobileUsers({accountIds, totalCount});

    return (
        <HeaderCaption
            isLoading={isLoading}
            loadingError={loadingError}
            columnId={COLUMNS.MOBILE_ENABLED_USERS}
        />
    );
};

export const MobileEnabledUsersHeader = () => {
    const result = useSelector(accountSearchResultResultSelector);

    return result ? (
        <MobileEnabledUsersHeaderController
            accountIds={result.data.map(({accountId}) => accountId)}
            totalCount={result.totalCount}
        />
    ) : (
        <HeaderSkeleton columnId={COLUMNS.MOBILE_ENABLED_USERS}/>
    );
};
